import { router } from "@/main";
import { authStateAtom } from "@/orm/auth";
import { Route } from "@/paths";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { VerifyYourEmailPage } from "../_pages/VerifyYourEmailPage/VerifyYourEmailPage";

export const RequireAuth = () => {
  const { user, loading } = useAtomValue(authStateAtom);

  useEffect(() => {
    if (!loading && !user) {
      if (location.pathname === Route.Login) return;

      router.navigate(Route.Login, {
        state: { returnTo: location.pathname },
      });
    }
  }, [loading, user]);

  if (loading) return null;
  if (!user?.emailVerified) return <VerifyYourEmailPage />;

  return <Outlet />;
};
